export enum EFinancasRoutes {
  credenciamento = "credenciamento",
  treinamentos = "treinamentos",
  antecipa = "inicio",
  antecipaContratacao = "antecipaContratacao",
  RegraDeRateio = "RegraDeRateio"
}
